export default __webpack_public_path__ + "img/mapy_logo-2dbf6c.svg";